let loginRoutePreloadPromise: Promise<unknown> | null = null;

export function preloadLoginRoute(): Promise<unknown> {
  if (!loginRoutePreloadPromise) {
    loginRoutePreloadPromise = Promise.all([
      import('../components/AuthenticatedAppShell'),
      import('../components/Login'),
    ]);
  }

  return loginRoutePreloadPromise;
}

export function scheduleLoginRoutePreload(): () => void {
  let timeoutId: number | undefined;
  let loadTimeoutId: number | undefined;
  let isCancelled = false;

  const preloadAfterInitialPaint = () => {
    if (isCancelled) {
      return;
    }

    void preloadLoginRoute();
  };

  const schedulePreload = () => {
    timeoutId = window.setTimeout(preloadAfterInitialPaint, 1_200);
  };

  if (document.readyState === 'complete') {
    schedulePreload();
  } else {
    loadTimeoutId = window.setTimeout(schedulePreload, 2_500);
    window.addEventListener('load', schedulePreload, { once: true });
  }

  return () => {
    isCancelled = true;
    window.removeEventListener('load', schedulePreload);

    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId);
    }

    if (loadTimeoutId !== undefined) {
      window.clearTimeout(loadTimeoutId);
    }
  };
}
